(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  href: _propTypes.string,
  info: _propTypes.string,
  text: _propTypes.string.isRequired,
  type: _propTypes.string,
  size: _propTypes.string,
  theme: _propTypes.string,
  outline: _propTypes.bool,
  cssClass: _propTypes.string,
  handleClick: _propTypes.func
};

// ImageCTA is a stateless functional component.
var Button = function Button(props) {
  var href = props.href,
    info = props.info,
    text = props.text,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type,
    size = props.size,
    theme = props.theme,
    _props$outline = props.outline,
    outline = _props$outline === void 0 ? false : _props$outline,
    _props$cssClass = props.cssClass,
    cssClass = _props$cssClass === void 0 ? "" : _props$cssClass,
    handleClick = props.handleClick;
  var buttonSize = size ? "hl__button--".concat(size) : "";
  var buttonStyle = outline ? "hl__button--minor" : "";
  var buttonTheme = theme ? "hl__button--".concat(theme) : "";
  var buttonClass = "hl__button ".concat(buttonSize, " ").concat(buttonTheme, " ").concat(buttonStyle, " ").concat(cssClass);
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: buttonClass,
      title: info
    }, text);
  } else {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: type,
      className: buttonClass,
      "aria-label": info,
      onClick: handleClick
    }, text);
  }
};
Button.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = Button;

},{"prop-types":"prop-types","react":"react"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  checked: _propTypes.bool.isRequired,
  icon: _propTypes.string,
  inline: _propTypes.bool,
  label: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  subLabel: _propTypes.string,
  theme: _propTypes.string,
  value: _propTypes.string.isRequired
};
var CheckboxFilter = function CheckboxFilter(props) {
  var handleChange = function handleChange(event) {
    props.onChange(event);
  };
  var name = props.name,
    value = props.value,
    label = props.label,
    _props$subLabel = props.subLabel,
    subLabel = _props$subLabel === void 0 ? "" : _props$subLabel,
    checked = props.checked,
    icon = props.icon,
    inline = props.inline,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? "dark" : _props$theme;
  var inlineClass = inline ? "hl__checkbox-filter--inline" : "";
  var themeClass = theme ? "hl__checkbox-filter--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: "hl__checkbox-filter ".concat(themeClass, " ").concat(inlineClass)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    name: name,
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: handleChange,
    className: "hl__checkbox-filter__label"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__checkbox-filter__container"
  }, icon && !inline && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: icon,
    alt: ""
  })), icon && inline && /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: icon,
    className: "hl__checkbox-filter__icon"
  }), subLabel === "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__label"
  }, label), subLabel !== "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__label"
  }, label, " \u2014 ", /*#__PURE__*/_react["default"].createElement("small", null, subLabel))));
};
CheckboxFilter.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = CheckboxFilter;

},{"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _checkboxFilter = _interopRequireDefault(require("../../01-atoms/forms/checkbox-filter.jsx"));
var _weekPicker = _interopRequireDefault(require("../../02-molecules/forms/week-picker.jsx"));
var _reactPicky = require("react-picky");
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterBarGroup = exports["default"] = /*#__PURE__*/function (_Component) {
  function FilterBarGroup() {
    var _this;
    _classCallCheck(this, FilterBarGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilterBarGroup, [].concat(args));
    _defineProperty(_this, "handleAccordion", function (e) {
      e.preventDefault();
      _this.props.accordionChange(_this.props.param, !_this.props.expanded);
    });
    _defineProperty(_this, "handleSelectChange", function (value) {
      var _this$props = _this.props,
        param = _this$props.param,
        onChange = _this$props.onChange;
      onChange(param, value);
    });
    return _this;
  }
  _inherits(FilterBarGroup, _Component);
  return _createClass(FilterBarGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.expanded == nextProps.expanded) {
        return;
      }
      var $content = (0, _jquery["default"])(this.accordionContent);
      if (nextProps.expanded) {
        $content.slideDown();
      } else {
        $content.slideUp();
      }
    }
  }, {
    key: "renderFilters",
    value: function renderFilters() {
      var _this$props2 = this.props,
        _this$props2$assetsUr = _this$props2.assetsUrl,
        assetsUrl = _this$props2$assetsUr === void 0 ? "../.." : _this$props2$assetsUr,
        param = _this$props2.param,
        onChange = _this$props2.onChange,
        filterType = _this$props2.filterType,
        _this$props2$selected = _this$props2.selected,
        selected = _this$props2$selected === void 0 ? [] : _this$props2$selected,
        items = _this$props2.items,
        placeholder = _this$props2.placeholder,
        label = _this$props2.label;
      switch (filterType) {
        case "checkbox":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_checkboxFilter["default"], _extends({
              key: param + item.value,
              onChange: onChange,
              name: param
            }, item));
          });
          break;
        case "select":
          return /*#__PURE__*/_react["default"].createElement(_reactPicky.Picky, {
            id: param,
            value: selected,
            name: param,
            options: items,
            multiple: true,
            includeSelectAll: false,
            includeFilter: false,
            onChange: this.handleSelectChange,
            dropdownHeight: 200,
            valueKey: 'value',
            labelKey: 'label',
            numberDisplayed: 0,
            placeholder: placeholder,
            manySelectedPlaceholder: placeholder + " (%s)"
          });
          break;
        case "keyword":
          return /*#__PURE__*/_react["default"].createElement("input", {
            className: "hl__input",
            "aria-label": label,
            name: param,
            id: param,
            type: "search",
            placeholder: placeholder,
            value: items.length && items[0].value ? items[0].value : "",
            onChange: onChange
          });
          break;
        case "weekPicker":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_weekPicker["default"], _extends({
              key: "single_date_".concat(index),
              assetsUrl: assetsUrl,
              onDateChange: onChange
            }, item));
          });
          break;
        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        label = _this$props3.label,
        expanded = _this$props3.expanded,
        filterType = _this$props3.filterType,
        hideAccordion = _this$props3.hideAccordion,
        accordionChange = _this$props3.accordionChange;
      var themeClass = filterType === "inline-checkbox" ? "hl__filter-bar-group--inline" : "";
      return /*#__PURE__*/_react["default"].createElement("fieldset", {
        className: "hl__filter-bar-group ".concat(themeClass)
      }, !hideAccordion && accordionChange && /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "hl__filter-bar-group__label",
        type: "button",
        "aria-expanded": expanded,
        onClick: this.handleAccordion
      }, label)), hideAccordion && /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-group__label"
      }, label)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-group__items",
        ref: function ref(el) {
          return _this2.accordionContent = el;
        }
      }, this.renderFilters()));
    }
  }]);
}(_react.Component);
_defineProperty(FilterBarGroup, "propTypes", {
  accordionChange: _propTypes.func,
  assetsUrl: _propTypes.string,
  expanded: _propTypes.bool.isRequired,
  filterType: _propTypes.string.isRequired,
  hideAccordion: _propTypes.bool,
  items: _propTypes.array.isRequired,
  label: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  param: _propTypes.string.isRequired,
  placeholder: _propTypes.string,
  selected: _propTypes.array // for select type
});

},{"../../01-atoms/forms/checkbox-filter.jsx":2,"../../02-molecules/forms/week-picker.jsx":5,"jquery":"jquery","prop-types":"prop-types","react":"react","react-picky":"react-picky"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _filterBarGroup = _interopRequireDefault(require("./filter-bar-group.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  message: _propTypes.string,
  groups: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    param: _propTypes.string.isRequired,
    expanded: _propTypes.bool.isRequired,
    items: _propTypes.array
  })).isRequired,
  onClearAll: _propTypes.func,
  title: _propTypes.string.isRequired,
  theme: _propTypes.string
};
var FilterBar = function FilterBar(props) {
  var renderGroups = function renderGroups(groups) {
    var assetsUrl = props.assetsUrl;
    return groups.filter(function (group) {
      return group.items && group.items.length;
    }).map(function (group) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar__group",
        key: group.param
      }, /*#__PURE__*/_react["default"].createElement(_filterBarGroup["default"], _extends({
        assetsUrl: assetsUrl
      }, group)));
    });
  };
  var groups = props.groups,
    title = props.title,
    onClearAll = props.onClearAll,
    assetsUrl = props.assetsUrl,
    message = props.message,
    theme = props.theme;
  var themeColor = theme ? "hl__filter-bar--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar ".concat(themeColor)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__container"
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: "hl__filter-bar__header"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__filter-bar__title"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__filters"
  }, renderGroups(groups), message && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__message"
  }, message)), onClearAll && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__clear"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "hl__filter-bar__clear-button",
    type: "button",
    "aria-label": "Clear all filters",
    onClick: onClearAll
  }, "Clear All"))));
};
FilterBar.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = FilterBar;

},{"./filter-bar-group.jsx":3,"prop-types":"prop-types","react":"react"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("react-dates/initialize");
var _reactDates = require("react-dates");
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = require("prop-types");
var _reactMomentProptypes = require("react-moment-proptypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // https://github.com/airbnb/react-dates
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  date: _reactMomentProptypes.momentObj.isRequired,
  focused: _propTypes.bool.isRequired,
  onFocusChange: _propTypes.func.isRequired,
  onDateChange: _propTypes.func.isRequired,
  properties: _propTypes.object,
  // optional settings
  navPrev: _propTypes.node,
  navNext: _propTypes.node
};
var WeekPicker = function WeekPicker(props) {
  var onChange = function onChange(date) {
    if (date.day() !== 0) {
      date.subtract(date.day(), "days");
    }
    props.onDateChange(date);
  };
  var onPreviousWeek = function onPreviousWeek() {
    props.onDateChange(props.date.subtract(7, "days"));
  };
  var onNextWeek = function onNextWeek() {
    props.onDateChange(props.date.add(7, "days"));
  };
  var assetsUrl = props.assetsUrl,
    properties = props.properties,
    focused = props.focused,
    date = props.date,
    onFocusChange = props.onFocusChange;
  var endDate = (0, _moment["default"])(date).add(6, "days").format("MMM DD, YYYY");
  var navPrev = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-733.000000, -834.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(690.000000, 790.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    transform: "translate(47.264520, 51.000000) scale(-1, 1) translate(-47.264520, -51.000000) ",
    points: "44.476406 58 51.2020202 51.0008077 44.476406 44 43.3270202 45.9416176 48.1873394 51.0008077 43.3270202 56.0583824"
  })))));
  var navNext = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-960.000000, -834.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(690.000000, 790.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "271.149386 58 277.875 51.0008077 271.149386 44 270 45.9416176 274.860319 51.0008077 270 56.0583824"
  })))));
  var downArrow = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask0_4901_183512",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "16",
    height: "16"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "16",
    height: "16",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#mask0_4901_183512)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.99967 11.7556L3.33301 7.08889L4.4219 6L7.99967 9.57778L11.5775 6L12.6663 7.08889L7.99967 11.7556Z",
    fill: "#A51C30"
  })));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__date-range"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__control"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: date < (0, _moment["default"])(),
    onClick: onPreviousWeek,
    type: "button",
    "aria-label": "Previous week",
    className: "hl__week-picker__control--previous"
  }, navPrev)), /*#__PURE__*/_react["default"].createElement(_reactDates.SingleDatePicker, _extends({
    date: date,
    focused: focused,
    onFocusChange: onFocusChange,
    onDateChange: onChange,
    navPrev: navPrev,
    navNext: navNext,
    showDefaultInputIcon: true,
    inputIconPosition: "after",
    customInputIcon: downArrow
  }, properties)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__week-picker__to-divider"
  }, "to"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__end-date__group"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__week-picker__end-date"
  }, endDate), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__control"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onNextWeek,
    type: "button",
    "aria-label": "Next week",
    className: "hl__week-picker__control--next"
  }, navNext)))));
};
WeekPicker.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = WeekPicker;

},{"moment":"moment","prop-types":"prop-types","react":"react","react-dates":"react-dates","react-dates/initialize":"react-dates/initialize","react-moment-proptypes":"react-moment-proptypes"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  href: _propTypes.string.isRequired,
  firstName: _propTypes.string.isRequired,
  lastName: _propTypes.string.isRequired,
  img: (0, _propTypes.shape)({
    src: _propTypes.string
  }),
  jobTitle: _propTypes.string,
  email: _propTypes.string
};
var StaffCard = function StaffCard(props) {
  var assetsUrl = props.assetsUrl,
    href = props.href,
    firstName = props.firstName,
    lastName = props.lastName,
    img = props.img,
    jobTitle = props.jobTitle,
    email = props.email;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__staff-card"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__staff-card__name"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "hl__link-tag",
    href: href,
    title: "more about ".concat(firstName, " ").concat(lastName)
  }, firstName, " ", lastName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__staff-card__email"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "hl__link-tag",
    href: "mailto:".concat(email),
    title: "email ".concat(firstName, " ").concat(lastName)
  }, /*#__PURE__*/_react["default"].createElement("span", null, email))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__staff-card__job-title"
  }, jobTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__staff-card__image"
  }, img && /*#__PURE__*/_react["default"].createElement("img", {
    src: img.src
  })));
};
StaffCard.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = StaffCard;

},{"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _staffCard = _interopRequireDefault(require("../../02-molecules/general/staff-card.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  }))
};
var StaffGrid = function StaffGrid(props) {
  var renderResults = function renderResults(results) {
    return results.map(function (r) {
      return /*#__PURE__*/_react["default"].createElement(_staffCard["default"], _extends({
        key: r.id,
        assetsUrl: props.assetsUrl
      }, r));
    });
  };
  var results = props.results;
  var gridClass = "hl__staff-grid--plain";
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__staff-grid ".concat(gridClass)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__staff-grid__container"
  }, renderResults(results)));
};
StaffGrid.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = StaffGrid;

},{"../../02-molecules/general/staff-card.jsx":6,"prop-types":"prop-types","react":"react"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _ramda = _interopRequireDefault(require("ramda"));
var _queryString = _interopRequireDefault(require("query-string"));
var _filterBar = _interopRequireDefault(require("../../02-molecules/forms/filter-bar.jsx"));
var _staffGrid = _interopRequireDefault(require("../../03-organisms/lists/staff-grid.jsx"));
var _button = _interopRequireDefault(require("../../01-atoms/buttons/button.jsx"));
var _reactSticky = require("react-sticky");
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StaffDirectoryApp = exports["default"] = /*#__PURE__*/function (_Component) {
  function StaffDirectoryApp(props) {
    var _this;
    _classCallCheck(this, StaffDirectoryApp);
    _this = _callSuper(this, StaffDirectoryApp, [props]);
    /********** Data Fetching ***************/
    // returns an array of properly formated filters
    _defineProperty(_this, "fetchLanguages", function () {
      return fetch("".concat(_this.props.requestUrl, "/api/v1/taxonomy/language?_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data.map(function (d) {
          return {
            label: d.label,
            value: d.tid
          };
        });
      })["catch"](function (error) {
        console.warn("failed to fetch languages:", error);
        return [];
      });
    });
    // returns an array of properly formated filters
    _defineProperty(_this, "fetchDepartments", function () {
      // departments are coming later
      return fetch("".concat(_this.props.requestUrl, "/api/v1/taxonomy/department?_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data.map(function (d) {
          return {
            label: d.label,
            value: d.tid
          };
        });
      })["catch"](function (error) {
        console.warn("failed to fetch departments:", error);
        return [];
      });
    });
    // returns an array of properly formated filters
    _defineProperty(_this, "fetchRoles", function () {
      return fetch("".concat(_this.props.requestUrl, "/api/v1/taxonomy/role?_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data.map(function (d) {
          return {
            label: d.label,
            value: d.tid
          };
        });
      })["catch"](function (error) {
        console.warn("failed to fetch Roles:", error);
        return [];
      });
    });
    // returns an array of properly formated filters
    _defineProperty(_this, "fetchLibraries", function () {
      return fetch("".concat(_this.props.requestUrl, "/api/v1/library?_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data;
      })["catch"](function (error) {
        console.warn("failed to fetch libraries:", error);
        return [];
      });
    });
    // optional loadMore boolean is used to append or replace the existing results
    _defineProperty(_this, "fetchGeneralResults", function () {
      var loadMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (loadMore) {
        _this.currentGeneralPage++;
      } else {
        _this.currentGeneralPage = 0;
      }
      var activeFilters = Object.assign({
        page: _this.currentGeneralPage,
        _format: "json"
      }, _this.queryString);
      _this.$ajaxGeneralResults.abort();
      _this.$ajaxGeneralResults = _jquery["default"].ajax({
        url: "".concat(_this.props.requestUrl, "/api/v1/staff"),
        data: activeFilters
      });
      _this.$ajaxGeneralResults.done(function (data) {
        var currentResults = _this.state.generalResults;
        var newResults = {
          totalCount: data.results.totalCount || 0,
          items: []
        };
        if (typeof data.results.items === "undefined" || data.results.items.length === 0) {
          if (!loadMore) {
            _this.setState({
              generalResults: newResults
            });
          }
          return;
        }
        var newItems = _this.parseResultItems(data.results.items);
        if (loadMore) {
          newResults.items = currentResults.items.concat(newItems);
        } else {
          newResults.items = newItems;
        }
        _this.setState({
          generalResults: newResults
        });
      }).fail(function (xhr, status, error) {
        console.warn("failed to fetch general results");
        var generalResults = _this.state.generalResults;
        generalResults.totalCount = 0;
        generalResults.items = [];
        _this.setState({
          generalResults: generalResults
        });
      });
    });
    /********** End Data Fetching ***************/
    /********** Data Manipulation ***************/
    _defineProperty(_this, "parseResultItems", function (data) {
      return data.map(function (item, i) {
        return {
          id: item.id,
          href: item.profile_link,
          firstName: item.first_name,
          lastName: item.last_name,
          img: item.image,
          jobTitle: item.job_title,
          email: item.email_link,
          role: item.role
        };
      });
    });
    _defineProperty(_this, "initializeFilters", function (filters) {
      var params = _this.queryString;
      if (params.name && filters.name.items.length) {
        filters.name.items[0].value = params.name;
      }
      if (params.department && filters.department.items.length) {
        if (typeof params.department === "string") {
          params.department = [params.department];
        }
        filters.department.selected = filters.department.items.filter(function (a) {
          return params.department.some(function (b) {
            return a.value === b;
          });
        });
      }
      if (params.language && filters.languages.items.length) {
        if (typeof params.language === "string") {
          params.language = [params.language];
        }
        filters.languages.selected = filters.languages.items.filter(function (a) {
          return params.language.some(function (b) {
            return a.value === b;
          });
        });
      }
      if (params.role && filters.role.items.length) {
        if (typeof params.role === "string") {
          params.role = [params.role];
        }
        filters.role.selected = filters.role.items.filter(function (a) {
          return params.role.some(function (b) {
            return a.value === b;
          });
        });
      }
      if (params.library && filters.library.items.length) {
        if (typeof params.library === "string") {
          params.library = [params.library];
        }
        filters.library.selected = filters.library.items.filter(function (a) {
          return params.library.some(function (b) {
            return a.value === b;
          });
        });
      }
      return filters;
    });
    // function takes two optional values
    // the url parameter and the value it should equal
    // if neither a parameter or value are passed,
    // we assume the queryString has been updated elsewhere
    // and we just need to reset the url
    _defineProperty(_this, "updateUrl", function (param) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // if a parameter and a value are passed add the new value
      if (param && value) {
        _this.queryString[param] = value;
      }
      // if a parameter is passed with a value remove the parameter
      if (param && (value === null || value.length === 0)) {
        delete _this.queryString[param];
      }
      var stringifiedQueries = _queryString["default"].stringify(_this.queryString);
      var newUrl = window.location.origin + window.location.pathname + "?" + stringifiedQueries;
      window.history.replaceState({
        path: newUrl
      }, "", newUrl);
    });
    /********** End Data Manipulation ***************/
    /********** Event Handlers ***************/
    _defineProperty(_this, "handleLoadMoreAll", function () {
      _this.fetchGeneralResults(true);
    });
    _defineProperty(_this, "onKeywordChange", function (event) {
      var filters = Object.assign({}, _this.state.filters);
      var value = event.target.value;
      filters.name.items[0].value = value;
      _this.updateUrl(filters.name.param, value);
      _this.setState({
        filters: filters
      });
      if (value.length > 1 || value.length === 0) {
        // fetch results
        _this.fetchResults();
      }
    });
    _defineProperty(_this, "onSelectChange", function (filterName, value) {
      var filters = Object.assign({}, _this.state.filters);
      for (var filterObj in filters) {
        if (filterName === filters[filterObj].param) {
          filters[filterObj].selected = value;
          _this.updateUrl(filterName, value.map(function (v) {
            return v.value;
          }));
          break;
        }
      }
      _this.setState({
        filters: filters
      });

      // fetch results
      _this.fetchResults();
    });
    // when an filter accordion expands or collapses
    // receives the key value of the filter and a boolean state
    _defineProperty(_this, "onAccordionChange", function (filterName, value) {
      var filters = Object.assign({}, _this.state.filters);
      for (var filterObj in filters) {
        if (filterName === filters[filterObj].param) {
          filters[filterObj].expanded = value;
          break;
        }
      }
      _this.setState({
        filters: filters
      });
    });
    // when the clear all button is clicked
    // receives the event from the button
    _defineProperty(_this, "onClearAll", function (event) {
      event.preventDefault();
      var oldFilters = _this.state.filters;
      var filters = _ramda["default"].map(function (filter) {
        if (filter.selected) {
          filter.selected = [];
        }
        return filter;
      }, oldFilters);
      filters.name.items[0].value = "";

      // clear the parameters in the url
      _this.queryString = {};
      _this.updateUrl();
      _this.fetchResults();
      _this.setState({
        filters: filters
      });
    });
    _this.state = {
      filters: {
        name: {
          label: "Filter Staff",
          placeholder: "Try last name or first name",
          param: "name",
          expanded: true,
          hideAccordion: true,
          filterType: "keyword",
          onChange: _this.onKeywordChange,
          items: [{
            value: ""
          }]
        },
        languages: {
          label: "Languages",
          placeholder: "Language",
          param: "language",
          expanded: true,
          hideAccordion: true,
          filterType: "select",
          onChange: _this.onSelectChange,
          selected: [],
          items: []
        },
        department: {
          label: "Affiliation",
          placeholder: "Affiliation",
          param: "department",
          expanded: true,
          hideAccordion: true,
          filterType: "select",
          onChange: _this.onSelectChange,
          selected: [],
          items: []
        },
        role: {
          label: "Role",
          placeholder: "Role",
          param: "role",
          expanded: true,
          hideAccordion: true,
          filterType: "select",
          onChange: _this.onSelectChange,
          selected: [],
          items: []
        },
        library: {
          label: "Library",
          placeholder: "Library",
          param: "library",
          expanded: true,
          hideAccordion: true,
          filterType: "select",
          onChange: _this.onSelectChange,
          selected: [],
          items: []
        }
      },
      generalResults: {
        totalCount: 0,
        items: []
      }
    };
    _this.currentGeneralPage = 0;
    _this.$ajaxGeneralResults = _jquery["default"].ajax();
    _this.queryString = _queryString["default"].parse(location.search); // params in the url
    _this.emptyMessage = "Loading...";
    return _this;
  }
  _inherits(StaffDirectoryApp, _Component);
  return _createClass(StaffDirectoryApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // fetch all languages
      var getLanguages = this.fetchLanguages();
      // fetch all departments
      var getDepartments = this.fetchDepartments();
      // fetch all roles
      var getRoles = this.fetchRoles();
      // fetch all Libraries
      var getLibraries = this.fetchLibraries().then(function (data) {
        var filters = data.map(function (library) {
          return {
            label: library.name,
            value: library.id
          };
        });
        return {
          filters: filters,
          libraries: data
        };
      });
      Promise.all([getLanguages, getDepartments, getRoles, getLibraries]).then(function (values) {
        var filters = Object.assign({}, _this2.state.filters);
        filters.languages.items = filters.languages.items.concat(values[0]);
        filters.department.items = filters.department.items.concat(values[1]);
        filters.role.items = filters.role.items.concat(values[2]);
        filters.library.items = filters.library.items.concat(values[3].filters);

        // mark filters found in the URL
        filters = _this2.initializeFilters(filters);

        // update state and render filters
        _this2.setState({
          filters: filters,
          libraries: values[3].buildings
        });

        // fetch results
        _this2.fetchResults();
        _this2.emptyMessage = "No Results";
      });
    }
  }, {
    key: "fetchResults",
    value:
    // fetches results from the api based on the filter values passed
    function fetchResults() {
      var loadMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.fetchGeneralResults(loadMore);
    }
  }, {
    key: "render",
    value: /********** End Event Handlers ***************/

    function render() {
      var _this3 = this;
      var assetsUrl = this.props.assetsUrl;
      var _this$state = this.state,
        filters = _this$state.filters,
        generalResults = _this$state.generalResults;
      var button = {
        text: "Load More",
        theme: "secondary"
      };
      var filterArray = [filters.name, filters.department, filters.library, filters.role, filters.languages];
      var currentResults = generalResults;
      var currentLoadMore = this.handleLoadMoreAll;
      return /*#__PURE__*/_react["default"].createElement(_reactSticky.StickyContainer, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-directory__app"
      }, /*#__PURE__*/_react["default"].createElement(_reactSticky.Sticky, null, function (_ref) {
        var style = _ref.style,
          isSticky = _ref.isSticky;
        return /*#__PURE__*/_react["default"].createElement("section", {
          style: _objectSpread({}, style),
          className: "hl__filter-bar-directory__filters",
          "data-sticky": isSticky ? 'sticky' : 'static'
        }, /*#__PURE__*/_react["default"].createElement(_filterBar["default"], {
          onClearAll: _this3.onClearAll,
          assetsUrl: assetsUrl,
          title: "Filter Staff",
          groups: filterArray,
          theme: "subtle"
        }));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-directory__container"
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__filter-bar-directory__results"
      }, currentResults.items.length > 0 && /*#__PURE__*/_react["default"].createElement(_staffGrid["default"], {
        assetsUrl: assetsUrl,
        results: currentResults.items
      }), currentResults.items.length === 0 && /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__filter-bar-directory__no-results"
      }, this.emptyMessage), currentResults.items && currentResults.items.length < currentResults.totalCount && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-directory__load-more"
      }, /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
        handleClick: currentLoadMore
      }, button)))))));
    }
  }]);
}(_react.Component);
_defineProperty(StaffDirectoryApp, "propTypes", {
  requestUrl: _propTypes.string.isRequired,
  assetsUrl: _propTypes.string.isRequired
});

},{"../../01-atoms/buttons/button.jsx":1,"../../02-molecules/forms/filter-bar.jsx":4,"../../03-organisms/lists/staff-grid.jsx":7,"jquery":"jquery","prop-types":"prop-types","query-string":"query-string","ramda":"ramda","react":"react","react-sticky":"react-sticky"}],9:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _filterBarDirectoryStaffApp = _interopRequireDefault(require("./filter-bar-directory-staff-app.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var el = document.querySelector(".js-staff-directory-app");
if (el) {
  var props = {
    requestUrl: el.getAttribute("data-request-url"),
    assetsUrl: el.getAttribute("data-assets-url")
  };
  (0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(_filterBarDirectoryStaffApp["default"], props), el);
}

},{"./filter-bar-directory-staff-app.jsx":8,"react":"react","react-dom":"react-dom"}],10:[function(require,module,exports){
"use strict";

var _filterBarDirectoryStaff = _interopRequireDefault(require("../_patterns/04-templates/base/filter-bar-directory-staff.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }

},{"../_patterns/04-templates/base/filter-bar-directory-staff.js":9}]},{},[10]);
